const COUNTRY_PROVINCES = {
    /*
    If you need a country that cannot have a province then add the country with a blank entry
    This will then fail if anything is added to the province field
    AL: [
        { value: "", text: "" }
    ],
    */
    // Postal code information from : https://www12.statcan.gc.ca/census-recensement/2006/ref/dict/tables/table-tableau-11-eng.cfm
    CA: [
        // t("Alberta")
        { value: "AB", text: "Alberta", postals: ["T"] },
        // t("British Columbia")
        { value: "BC", text: "British Columbia", postals: ["V"] },
        // t("Manitoba")
        { value: "MB", text: "Manitoba", postals: ["R"] },
        // t("New Brunswick")
        { value: "NB", text: "New Brunswick", postals: ["E"] },
        // t("Newfoundland and Labrador")
        { value: "NL", text: "Newfoundland and Labrador", postals: ["A"] },
        // t("Nova Scotia")
        { value: "NS", text: "Nova Scotia", postals: ["B"] },
        // t("Ontario",)
        { value: "ON", text: "Ontario", postals: ["K", "L", "M", "N", "P"] },
        // t("Prince Edward Island")
        { value: "PE", text: "Prince Edward Island", postals: ["C"] },
        // t("Quebec")
        { value: "QC", text: "Quebec", postals: ["G", "H", "J"] },
        // t("Saskatchewan",)
        { value: "SK", text: "Saskatchewan", postals: ["S"] },
        // t("Northwest Territories")
        { value: "NT", text: "Northwest Territories", postals: ["X"] },
        // t("Nunavut")
        { value: "NU", text: "Nunavut", postals: ["X"] },
        // t("Yukon")
        { value: "YT", text: "Yukon", postals: ["Y"] },
    ],
    // Zip code information from http://www.directmailmanagerri.com/pdfs/zipcode_list_for_US_states.pdf
    // with corrections/accuracy thanks to https://en.wikipedia.org/wiki/List_of_ZIP_Code_prefixes and
    // https://stevemorse.org/jcal/zipdetails.html
    US: [
        // t("U.S. Armed Forces - Americas")
        { value: "AA", text: "U.S. Armed Forces - Americas", zips: [340] },
        // t("U.S. Armed Forces - Europe")
        {
            value: "AE",
            text: "U.S. Armed Forces - Europe",
            zips: [{ min: 90, max: 99 }],
        },
        // t("Alabama")
        { value: "AL", text: "Alabama", zips: [{ min: 350, max: 369 }] },
        // t("Alaska")
        { value: "AK", text: "Alaska", zips: [{ min: 995, max: 999 }] },
        // t("U.S. Armed Forces - Pacific")
        {
            value: "AP",
            text: "U.S. Armed Forces - Pacific",
            zips: [{ min: 962, max: 966 }],
        },
        // t("Arizona")
        { value: "AZ", text: "Arizona", zips: [{ min: 850, max: 865 }] },
        // t("Arkansas")
        { value: "AR", text: "Arkansas", zips: [{ min: 716, max: 729 }] },
        // t("California")
        { value: "CA", text: "California", zips: [{ min: 900, max: 966 }] },
        // t("Colorado")
        { value: "CO", text: "Colorado", zips: [{ min: 800, max: 816 }] },
        // t("Connecticut")
        { value: "CT", text: "Connecticut", zips: [{ min: 60, max: 69 }] },
        // t("Delaware")
        { value: "DE", text: "Delaware", zips: [{ min: 197, max: 199 }] },
        // t("District Of Columbia")
        {
            value: "DC",
            text: "District Of Columbia",
            zips: [{ min: 200, max: 205 }],
        },
        // t("Florida")
        { value: "FL", text: "Florida", zips: [{ min: 320, max: 349 }] },
        // t("Georgia")
        {
            value: "GA",
            text: "Georgia",
            zips: [{ min: 300, max: 319 }, 398, 399],
        },
        // t("Hawaii")
        { value: "HI", text: "Hawaii", zips: [{ min: 967, max: 968 }] },
        // t("Idaho")
        { value: "ID", text: "Idaho", zips: [{ min: 832, max: 838 }] },
        // t("Illinois")
        { value: "IL", text: "Illinois", zips: [{ min: 600, max: 629 }] },
        // t("Indiana")
        { value: "IN", text: "Indiana", zips: [{ min: 460, max: 479 }] },
        // t("Iowa")
        { value: "IA", text: "Iowa", zips: [{ min: 500, max: 528 }] },
        // t("Kansas")
        { value: "KS", text: "Kansas", zips: [{ min: 660, max: 679 }] },
        // t("Kentucky")
        { value: "KY", text: "Kentucky", zips: [{ min: 400, max: 427 }] },
        // t("Louisiana")
        { value: "LA", text: "Louisiana", zips: [{ min: 700, max: 714 }] },
        // t("Maine")
        { value: "ME", text: "Maine", zips: [{ min: 39, max: 49 }] },
        // t("Maryland")
        { value: "MD", text: "Maryland", zips: [{ min: 206, max: 219 }] },
        // t("Massachusetts")
        {
            value: "MA",
            text: "Massachusetts",
            zips: [{ min: 10, max: 27 }, 55],
        },
        // t("Michigan")
        { value: "MI", text: "Michigan", zips: [{ min: 480, max: 499 }] },
        // t("Minnesota")
        { value: "MN", text: "Minnesota", zips: [{ min: 550, max: 597 }] },
        // t("Mississippi")
        { value: "MS", text: "Mississippi", zips: [{ min: 386, max: 397 }] },
        // t("Missouri")
        { value: "MO", text: "Missouri", zips: [{ min: 630, max: 658 }] },
        // t("Montana")
        { value: "MT", text: "Montana", zips: [{ min: 590, max: 599 }] },
        // t("Nebraska")
        { value: "NE", text: "Nebraska", zips: [{ min: 680, max: 693 }] },
        // t("Nevada")
        { value: "NV", text: "Nevada", zips: [{ min: 889, max: 898 }] },
        // t("New Hampshire")
        { value: "NH", text: "New Hampshire", zips: [{ min: 30, max: 39 }] },
        // t("New Jersey")
        { value: "NJ", text: "New Jersey", zips: [{ min: 70, max: 89 }] },
        // t("New Mexico")
        { value: "NM", text: "New Mexico", zips: [{ min: 870, max: 884 }] },
        // t("New York")
        { value: "NY", text: "New York", zips: [5, 63, { min: 90, max: 149 }] },
        // t("North Carolina")
        { value: "NC", text: "North Carolina", zips: [{ min: 269, max: 289 }] },
        // t("North Dakota")
        { value: "ND", text: "North Dakota", zips: [{ min: 580, max: 588 }] },
        // t("Ohio")
        { value: "OH", text: "Ohio", zips: [{ min: 430, max: 459 }] },
        // t("Oklahoma")
        { value: "OK", text: "Oklahoma", zips: [{ min: 730, max: 749 }] },
        // t("Oregon")
        { value: "OR", text: "Oregon", zips: [{ min: 970, max: 979 }] },
        // t("Pennsylvania")
        { value: "PA", text: "Pennsylvania", zips: [{ min: 150, max: 196 }] },
        // t("Rhode Island")
        { value: "RI", text: "Rhode Island", zips: [{ min: 28, max: 29 }] },
        // t("South Carolina")
        { value: "SC", text: "South Carolina", zips: [{ min: 290, max: 299 }] },
        // t("South Dakota")
        { value: "SD", text: "South Dakota", zips: [{ min: 570, max: 577 }] },
        // t("Tennessee")
        { value: "TN", text: "Tennessee", zips: [{ min: 370, max: 385 }] },
        // t("Texas")
        { value: "TX", text: "Texas", zips: [{ min: 750, max: 799 }, 885] },
        // t("Utah")
        { value: "UT", text: "Utah", zips: [{ min: 840, max: 847 }] },
        // t("Vermont")
        { value: "VT", text: "Vermont", zips: [{ min: 50, max: 59 }] },
        // t("Virginia")
        { value: "VA", text: "Virginia", zips: [201, { min: 220, max: 246 }] },
        // t("Washington")
        { value: "WA", text: "Washington", zips: [{ min: 980, max: 994 }] },
        // t("West Virginia")
        { value: "WV", text: "West Virginia", zips: [{ min: 247, max: 268 }] },
        // t("Wisconsin")
        { value: "WI", text: "Wisconsin", zips: [{ min: 530, max: 549 }] },
        // t("Wyoming")
        { value: "WY", text: "Wyoming", zips: [{ min: 820, max: 831 }] },
    ],
};

function countryHasProvince(country, province) {
    if (!country) {
        return false;
    }
    if (COUNTRY_PROVINCES[country.toUpperCase()] === undefined) {
        // Assume an unknown country doesn't need to check for a province
        return true;
    }
    province = province || "";
    return !!COUNTRY_PROVINCES[country.toUpperCase()].find((p) => p.value === province.toUpperCase());
}

/*
 * Checks that a province (or US State) has the provided postal code (or ZIP code) to prevent
 * someone setting the wrong code or province.
 */
function provinceHasPostalCode(country, province, postalCode) {
    if (!country) {
        return false;
    }
    postalCode = (postalCode || "").trim().toUpperCase();
    if (country === "CA") {
        // Verify valid postal code
        if (!/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(postalCode)) {
            return false;
        }
        const info = COUNTRY_PROVINCES[country.toUpperCase()].find((p) => p.value === province.toUpperCase());
        if (!info) {
            return false;
        }
        return info.postals.some((prefix) => postalCode[0] === prefix);
    } else if (country === "US") {
        if (!/^[0-9]{5}$/.test(postalCode)) {
            if (/^[0-9]{5}[-+ X]?[0-9]{4}$/.test(postalCode)) {
                // Transform 9 digit zip into 5 digit
                postalCode = postalCode.slice(0, 5);
            } else {
                return false;
            }
        }
        const zipPrefix = parseInt(postalCode.slice(0, 3));
        const info = COUNTRY_PROVINCES[country.toUpperCase()].find((p) => p.value === province.toUpperCase());
        if (!info) {
            return false;
        }
        return info.zips.some((prefix) => {
            if (prefix.min && prefix.max) {
                return zipPrefix >= prefix.min && zipPrefix <= prefix.max;
            }
            return zipPrefix == prefix;
        });
    }
    return true;
}

module.exports = {
    COUNTRY_PROVINCES,
    countryHasProvince,
    provinceHasPostalCode,
};
